import React, { Component } from 'react';

import slugify from 'utils/slugify';
import get from 'utils/get';
import getUrlParam from 'utils/getUrlParam';
import scrollTo from 'react-scroll-to-component';
import marked from 'marked';
import cx from 'classnames';

import LaureateStoryHero from 'components/LaureateStoryHero';
import LaureateStoryFooter from 'components/LaureateStoryFooter';
import BlockSwitch from 'components/BlockSwitch';
import SocialLinks from 'components/SocialLinks';
import { Image, Button } from 'components/base';
import withMeta from 'lib/withMeta';

class LaureateStoryView extends Component {
  constructor(props) {
    super(...arguments);

    this.state = {
      hideLaureateTransition: false
    };

    this.hideLaureateTransition();
    this.storyContainerRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.setState({ hideLaureateTransition: false });
      this.hideLaureateTransition();
    }
  }

  componentDidMount() {
    const { slug } = this.props;
    const tag = getUrlParam('keyword');

    if (!!tag && !!window.WINSTEM.refs[`${slug}-${tag}`]) {
      const element = window.WINSTEM.refs[`${slug}-${tag}`];

      setTimeout(
        () =>
          scrollTo(element, {
            duration: 0,
            align: 'middle'
          }),
        1500
      );
    }

    const linkedToExploreElement = document.getElementsByClassName(
      'linked-to-explore'
    );
    const linkedElementLength = linkedToExploreElement.length;
    if (!!linkedElementLength) {
      for (let i = 0; i < linkedElementLength; i++) {
        const element = linkedToExploreElement[i];
        const innerText = element.innerText.toLowerCase();
        const selectedKeyword = window.WINSTEM.keywords.Topic.map(
          topic => Object.keys(topic)[0]
        ).find(keyword => {
          return innerText.startsWith(keyword);
        });

        element.addEventListener('click', e => {
          e.preventDefault();
          this.props.history.push(
            `/explore?keyword=${encodeURIComponent(selectedKeyword)}`
          );
        });
      }
    }
  }

  hideLaureateTransition = () => {
    setTimeout(() => this.setState({ hideLaureateTransition: true }), 2000);
  };

  scrollToTop = () => {
    scrollTo(this.storyContainerRef.current, {
      duration: 1000,
      align: 'top'
    });
  };

  render() {
    const {
      model,
      laureateStory,
      globalSettings,
      backgroundLineKeywords
    } = this.props;

    if (model.isError) return <h1>Error</h1>;
    if (!laureateStory) return <h1>No Laureate Story Found</h1>;

    const contentBlocks = get(laureateStory, 'contentBlocks', []);
    const currentLaureate = get(laureateStory, 'slug', '');
    const image = get(laureateStory, 'image', {});
    const award = get(laureateStory, 'awardTimeLine', '');
    const relatedLaureates = get(laureateStory, 'relatedLaureates', []);
    const heroImageCredit = get(laureateStory, 'heroImageCredit', '');

    return (
      <div
        ref={this.storyContainerRef}
        style={{ backgroundColor: globalSettings.backgroundColor }}
        id="LaureateStoryView"
        className={`LaureateStoryView relative w100 overflow-hidden color-${slugify(
          globalSettings.contentColor
        )}`}
      >
        {!!getUrlParam('keyword') ? (
          <div
            style={{ backgroundColor: globalSettings.backgroundColor }}
            className={cx(
              'fixed vw100 vh100 z-cover transition flex items-center justify-center',
              {
                'opacity-0 events-none': this.state.hideLaureateTransition
              }
            )}
          >
            <Image
              className="relative wh100 fit-cover md:p4 md:fit-contain"
              alt={get(image, 'title', '')}
              src={get(image, 'url', '')}
            />
            <div className="absolute wh100 flex flex-col items-center justify-center">
              <h2 className="hero-title color-white z1 flex flex-col items-center mt4 text-center">
                <span>{laureateStory.firstName}</span>
                <span>{laureateStory.middleName}</span>
                <span>{laureateStory.lastName}</span>
              </h2>
              <div
                className={cx(
                  'mt2 md:none caption caption-text-width markdown-text text-center color-cloud-gray'
                )}
                dangerouslySetInnerHTML={{
                  __html: marked(award)
                }}
              />
            </div>
          </div>
        ) : null}
        <LaureateStoryHero laureateStory={laureateStory} />
        {heroImageCredit ? (
          <div
            className="m1_5 caption markdown-text"
            dangerouslySetInnerHTML={{
              __html: marked(heroImageCredit)
            }}
          />
        ) : null}
        <div className="py3 md:py6">
          <div className="px2_5 lg:none">
            <SocialLinks />
          </div>
          {contentBlocks.length &&
            contentBlocks.map((block, i) => (
              <BlockSwitch
                backgroundLineKeywords={backgroundLineKeywords}
                key={get(block, 'sys.id', i)}
                block={block}
                currentLaureate={currentLaureate}
                isFirst={i === 0}
              />
            ))}
          <div className="w100 mxauto text-block-width px2_5 md:px0 flex justify-between">
            <SocialLinks />
            <Button
              color={slugify(globalSettings.contentColor)}
              onClick={this.scrollToTop}
            >
              <span className="text-back-to-top mr_5">Back to top</span>
              <Image
                className="small-icon-width"
                alt="Back to top"
                src={`${
                  process.env.PUBLIC_URL
                }/assets/images/icon-up-arrow.svg`}
              />
            </Button>
          </div>
          {relatedLaureates.length && (
            <LaureateStoryFooter
              contentColor={slugify(globalSettings.contentColor)}
              relatedLaureates={relatedLaureates}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withMeta(LaureateStoryView, 'laureateStory');
